/* src/app/private/components/add-user/add-user.component.scss */
.p-inputtext {
  box-shadow: none !important;
}
.p-select {
  box-shadow: none !important;
}
label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
}
.force-style {
  border-radius: 5px !important;
  padding: 8px !important;
}
.p-password input {
  border-radius: 8px !important;
}
.p-password-input {
  border-radius: 8px !important;
}
/*# sourceMappingURL=add-user.component.css.map */
